import { render } from "./PaiementRegulation.vue?vue&type=template&id=51c695fa&ts=true"
import script from "./PaiementRegulation.vue?vue&type=script&lang=ts"
export * from "./PaiementRegulation.vue?vue&type=script&lang=ts"

import "./PaiementRegulation.vue?vue&type=style&index=0&id=51c695fa&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__